import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MinusCircleIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" fill="none" viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666M6.667 10h6.666"
      />
    </Icon>
  );
}
